export default __webpack_public_path__ + "static/media/04-icon-zertifizierung.04e8017f.svg";